import { createSelector } from 'reselect';

const profileSelect = ({ profile }) => profile;

export const selectPersonalData = createSelector(profileSelect, ({ personalData }) => personalData);

export const selectPersonalDataContent = createSelector(selectPersonalData, (state) =>
  state.get('data'),
);

export const selectPersonalDataIsLoading = createSelector(selectPersonalData, (state) =>
  state.get('loading'),
);

export const selectDocCode = createSelector(selectPersonalData, (state) =>
  state.get('data') ? state.get('data').code : 0,
);

export const selectHasRussianPassport = createSelector(selectDocCode, (code) => code === '21');

export const selectPlaceOfBirth = createSelector(selectPersonalData, (state) =>
  state.get('data') ? state.get('data').placeOfBirth : null,
);

export const selectDateOfBirth = createSelector(selectPersonalData, (state) =>
  state.get('data') ? state.get('data').dateOfBirth : null,
);
